<div id="FakturagodkendelseListe" [ngClass]="{ expanded: erAktiv() }">
  <div class="overlay" (click)="close(null)"></div>
  <mat-accordion [ngClass]="{ open: erAktiv() }">
    @for (f of fakturaer; track f) {
      <mat-expansion-panel
        class="faktura"
        [expanded]="faktura === f"
        #expansionPanel
        (opened)="open(f)"
        (closed)="close(f)"
        tabindex="0"
        >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div>
              <span>Kreditornr.</span>
              <div>{{ f.kreditornr }}</div>
            </div>
          </mat-panel-title>
          <mat-panel-title>
            <div>
              <span>Fakturanr.</span>
              <div>{{ f.fakturanr }}</div>
            </div>
          </mat-panel-title>
          <mat-panel-title>
            <div>
              <span>Fakturadato</span>
              <div>{{ f.fakturadato | date : "dd-MM-yyyy" }}</div>
            </div>
          </mat-panel-title>
          <mat-panel-title>
            <div>
              <span>Forfaldsdato</span>
              <div>{{ f.forfaldsdato | date : "dd-MM-yyyy" }}</div>
            </div>
          </mat-panel-title>
          <mat-panel-title class="hidden-xs">
            <div>
              <span>Modpostering</span>
              <div>{{ f.modpost }}</div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @if (erAktiv(f)) {
          <div class="detaljer">
            <mat-button-toggle-group (change)="onButtonToggleGroupChange($event, f)">
              <mat-button-toggle class="afvent" value="afvent">Afvent</mat-button-toggle>
              <mat-button-toggle class="afvis" value="afvis">Afvis</mat-button-toggle>
              <mat-button-toggle class="godkend" value="godkend">Godkend</mat-button-toggle>
            </mat-button-toggle-group>
            <dff-pdf-fremviser #pdfFremviser [dokumentUrler]="f.dokumentUrler"></dff-pdf-fremviser>
          </div>
        }
        @if (f === faktura && fullyExpanded) {
          <mat-accordion
            style="z-index: 0"
            class="bottom-panel"
            tabindex="0"
            aria-labelledby="details-panel-text"
            >
            <mat-expansion-panel #expansionPanel>
              <mat-expansion-panel-header>
                <mat-panel-title fxLayoutAlign="center">
                  <span id="details-panel-text">
                    {{ !expansionPanel.expanded ? "Klik for at se detaljer" : "Klik for at skjule detaljer" }}
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="table">
                <div class="tr">
                  <div class="td title">Dokumenttype</div>
                  <div class="td">{{ f.dokumenttypetekst }}</div>
                </div>
                <div class="tr">
                  <div class="td title">Faktura-/kreditnotanummer</div>
                  <div class="td">{{ f.fakturanr }}</div>
                </div>
                <div class="tr">
                  <div class="td title">Rekvisitionsnummer</div>
                  <div class="td">{{ f.rekvisitionsnr }}</div>
                </div>
                <div class="tr">
                  <div class="td title">Fakturadato</div>
                  <div class="td">{{ f.fakturadato | date : "dd-MM-yyyy" }}</div>
                </div>
                <div class="tr">
                  <div class="td title">Forfaldstato</div>
                  <div class="td">{{ f.forfaldsdato | date : "dd-MM-yyyy" }}</div>
                </div>
                <div class="tr">
                  <div class="td title">Bel&oslash;b til betaling</div>
                  <div class="td">{{ f.beloeb | number : "1.2-2" }}</div>
                </div>
                <div class="tr">
                  <div class="td title">Modpost</div>
                  <div class="td">{{ f.modpost }}</div>
                </div>
                <div class="tr">
                  <div class="td title">Afdeling</div>
                  <div class="td">{{ f.afdelingtekst }}</div>
                </div>
                <div class="tr">
                  <div class="td title">Projekt</div>
                  <div class="td">{{ f.projekttekst }}</div>
                </div>
                <div class="tr">
                  <div class="td title">Enheder</div>
                  <div class="td">{{ f.enheder }}</div>
                </div>
                <div class="tr">
                  <div class="td title">Konteringstekst</div>
                  <div class="td">{{ f.konteringstekst }}</div>
                </div>
                <div class="tr">
                  <div class="td title">Konteringstekst 2</div>
                  <div class="td">{{ f.konteringstekst2 }}</div>
                </div>
                <div class="tr">
                  <div class="td title">Konteringstekst 3</div>
                  <div class="td">{{ f.konteringstekst3 }}</div>
                </div>
                <div class="tr">
                  <div class="td title">Bem&aelig;rkning</div>
                  <div class="td" [innerHtml]="tilfoejLinjeskift(f)"></div>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        }
      </mat-expansion-panel>
    }
  </mat-accordion>
</div>
